import axios from 'axios';
import { saveAs } from 'file-saver';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DownloadCSV = () => {
  const location = useLocation();
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }
  useEffect(() => {
    const search = location.state?.search ?? location.search
    if (search) {
      let searchParams = new URLSearchParams(search)
      // axios.get(searchParams.get("download_url")).then((res) => {
      //   const filename = uuidv4()
      //   var blob = new Blob([res.data], { type: "text/csv;charset=utf-8" });
      //   saveAs(blob, `${filename}.csv`);
      // })
      window.open(searchParams.get("download_url"));
      setTimeout(() => {
        window.close();
      }, 3000)
    }
    // eslint-disable-next-line
  }, [location.search, location.state?.search])

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    }}>

    </div>
  );
};

export default DownloadCSV;